import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { forgotPassword } from '../Services/UserService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("loginDetail")) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');
    setLoading(true);

    const res = await forgotPassword(email);
    setLoading(false);

    if (res.status) {
      setSuccessMsg(res.message || 'A password reset link has been successfully sent to your email.');
    } else {
      setErrorMsg(res.message || 'Error processing forgot password request.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="card p-4 shadow" style={{ width: '100%', maxWidth: '462px', minHeight: '400px', borderRadius: '20px' }}>
        {/* Logo */}
        <div className="text-center mb-4">
          <img src={logo} alt="Logo" className="img-fluid" style={{ maxHeight: '80px' }} />
        </div>

        <h4 className="text-center fw-bold mb-3 mt-2" style={{ color: '#A37C4D' }}>Forgot Password</h4>
        <p className="text-muted text-center fs-6 mb-4">
          Enter your registered email address and we'll send you a link to reset your password.
        </p>

        {/* Success / Error Alerts */}
        {successMsg ? (
          <div className="text-center mt-3">
            <div className="alert alert-success p-3 text-center fs-6 mb-4" role="alert">
              {successMsg}
            </div>
            <button
              onClick={() => navigate('/login')}
              className="btn custom-login-btn w-100"
            >
              GO BACK TO LOGIN
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {errorMsg && (
              <div className="alert alert-danger p-2 text-center fs-6 mb-3" role="alert">
                {errorMsg}
              </div>
            )}

            {/* Email Input */}
            <div className="mb-4">
              <label htmlFor="reset-email" className="form-label fs-6 fw-semibold">
                Registered Email
              </label>
              <input
                type="email"
                className="form-control"
                id="reset-email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Action Buttons */}
            <div className="d-flex justify-content-between align-items-center gap-3 mt-4">
              <button
                type="button"
                className="btn btn-outline-secondary py-2 fs-6 fw-semibold flex-grow-1"
                style={{ borderRadius: '20px' }}
                onClick={() => navigate('/login')}
              >
                CANCEL
              </button>
              <button
                type="submit"
                className="btn custom-login-btn py-2 flex-grow-1"
                disabled={loading}
              >
                {loading ? 'SENDING...' : 'SEND LINK'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
